import './../../styles/templates/search.scss';
import { debounce } from "lodash";

const PRODUCTS_CONTAINER_ID = 'SearchGridContainer';

class FacetFiltersSearchForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce(e => {
      this.onSubmitHandler(e);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersSearchForm.searchParamsInitial;
      if (searchParams === FacetFiltersSearchForm.searchParamsPrev) return;
      FacetFiltersSearchForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    document.getElementById(PRODUCTS_CONTAINER_ID).classList.add('loading');
    const url = `${window.location.pathname}?${searchParams}`;
    const filterDataUrl = element => element.url === url;

    FacetFiltersSearchForm.filterData.some(filterDataUrl) ?
      FacetFiltersSearchForm.renderSectionFromCache(filterDataUrl, event) :
      FacetFiltersSearchForm.renderSectionFromFetch(url, event);

    if (updateURLHash) FacetFiltersSearchForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersSearchForm.filterData = [...FacetFiltersSearchForm.filterData, { html, url }];
        FacetFiltersSearchForm.renderFilters(html);
        FacetFiltersSearchForm.renderProductGridContainer(html);
        FacetFiltersSearchForm.completeRenderPage();
      })
      .catch(e => {
        console.error(e);
        FacetFiltersSearchForm.completeRenderPage();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersSearchForm.filterData.find(filterDataUrl).html;
    FacetFiltersSearchForm.renderFilters(html);
    FacetFiltersSearchForm.renderProductGridContainer(html);
    FacetFiltersSearchForm.completeRenderPage();
  }

  static completeRenderPage() {
    const gridContainer = document.getElementById(PRODUCTS_CONTAINER_ID);
    gridContainer.classList.remove('loading');

    if (window.pingInit.proxyLinkSetup) window.pingInit.proxyLinkSetup(gridContainer);

    window.endlessScroll = new Ajaxinate({
      container: '#AjaxinateContainer',
      pagination: '#AjaxinatePagination',
      method: 'click',
      callback: function (requestURL) {
        window.pingInit.ajaxinateCallBack(requestURL);
      }
    });
  }

  static renderProductGridContainer(html) {
    document.getElementById(PRODUCTS_CONTAINER_ID).innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById(PRODUCTS_CONTAINER_ID).innerHTML;
  }

  static renderFilters(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const searchFiltersContainer = document.querySelector('.search-filters');
    const newSearchFiltersContainer = parsedHTML.querySelector('.search-filters');

    if(searchFiltersContainer) {
      searchFiltersContainer.innerHTML = newSearchFiltersContainer.innerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  alternateFilters(activeFilter) {
    const $activeFilter = $(activeFilter);
    const $activeFilterWrapper = $activeFilter.parents('.search__filter');

    if(!$activeFilterWrapper.hasClass('selected')) {
      const $allFilters = $('.search__filter input[type="checkbox"]');
      $allFilters.prop('checked', false);
      $activeFilter.prop('checked', true);
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();

    this.alternateFilters(event.target);

    const availbleCheckbox = this.querySelector('.facets__section--availability input[type="checkbox"][value="1"]');
    if (availbleCheckbox) {
      if (this.querySelectorAll('.facets__section:not(.facets__section--availability) input[type="checkbox"]:checked').length > 0) {
        availbleCheckbox.checked = true;
      } else {
        availbleCheckbox.checked = false;
      }
    }
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString()

    FacetFiltersSearchForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersSearchForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersSearchForm.renderPage(url);
  }
}

FacetFiltersSearchForm.filterData = [];
FacetFiltersSearchForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersSearchForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-search-form', FacetFiltersSearchForm);
FacetFiltersSearchForm.setListeners();
